import { linkStyle } from "@repo/ui/Link/index";
import type { TeammateReferenceWrapperProps } from "@repo/ui/structuredContent/teammateReferenceContext";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";
import { appPaths } from "../../app/appPaths.js";
import { usePlaybookIdParam } from "../../hooks/usePlaybookIdParam.js";
import { DEFAULT_PLAYBOOK_URL_SEGMENT } from "../links/defaultPlaybookRedirect.js";

/**
 * Links structured content teammate references to the teammate's page, in a
 * new tab like grading references. The page is playbook-scoped: the link uses
 * the playbook the reference resolved to, else the current page's playbook,
 * else the viewer's default playbook. Supplied to the shared renderers via
 * `TeammateReferenceProvider`.
 */
export const TeammateReferenceLinkAdapter: FC<TeammateReferenceWrapperProps> = (
  props,
) => {
  const { reference, className, children } = props;
  const pagePlaybookId = usePlaybookIdParam();
  return (
    <a
      href={appPaths.teammate.build({
        playbookId:
          reference.playbookId ??
          pagePlaybookId ??
          DEFAULT_PLAYBOOK_URL_SEGMENT,
        teammateId: reference.teammateId,
      })}
      target="_blank"
      rel="noopener noreferrer"
      className={twMerge(linkStyle(), className)}
    >
      {children}
    </a>
  );
};
